"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSetRealmAuthority = void 0;
var withSetRealmAuthority_1 = require("./withSetRealmAuthority");
function createSetRealmAuthority(programId, programVersion, realm, realmAuthority, newRealmAuthority, action) {
    var instructions = [];
    (0, withSetRealmAuthority_1.withSetRealmAuthority)(instructions, programId, programVersion, realm, realmAuthority, newRealmAuthority, action);
    return instructions[0];
}
exports.createSetRealmAuthority = createSetRealmAuthority;
//# sourceMappingURL=createSetRealmAuthority.js.map